'use client';

import React from 'react';
import { Container, Title, Text, Button, Stack, Center } from '@mantine/core';
import { IconError404 } from '@tabler/icons-react';
import Link from 'next/link';
import useSafeTranslation from '@/hooks/useSafeTranslation';

export default function NotFound() {
  const { tSafe: t } = useSafeTranslation();

  return (
    <Container size="sm" py="xl">
      <Center mih="60vh">
        <Stack align="center" gap="lg">
          <IconError404 size={48} />
          <Title order={1}>{t('notFoundTitle') ?? 'Page not found'}</Title>
          <Text c="dimmed" ta="center">
            {t('notFoundDescription') ?? 'The page you are looking for does not exist.'}
          </Text>
          <Link href="/">
            <Button>{t('errorHome') ?? 'Go home'}</Button>
          </Link>
        </Stack>
      </Center>
    </Container>
  );
}
